/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import '../../../fonts/fonts.scss';

/**
 * A default font loader function that performs no operations.
 * This is intended as a placeholder for default font loading.
 *
 * ```typescript
 *  import DefaultFontLoader from './DefaultFontLoader';
 * 
 *  const result = DefaultFontLoader(); // null
 * ```
 *
 * @returns `null`
 */
export const DefaultFontLoader = () => null;

export default DefaultFontLoader;
